import PropTypes from 'prop-types';
import React from 'react';

import PrimaryButton from '../atoms/PrimaryButton';
import { EditAction } from '../utils/PermissionComponent';

class BulkUpdateExecButton extends React.Component {
  static get propTypes() {
    return {
      onClick: PropTypes.func,
      isEnabled: PropTypes.func,
    };
  }

  render() {
    return (
      <EditAction>
        <PrimaryButton
          onClick={this.props.onClick}
          isEnabled={this.props.isEnabled}
        >
          実行
        </PrimaryButton>
      </EditAction>
    );
  }
}

export default BulkUpdateExecButton;
